import React from 'react';
import {Form, formsStore} from '../../../../stores/Form';
import {observer} from 'mobx-react';
import {texts} from './texts';
import {HeaderHelpButton} from '../../../../_shared/Help/components/FormHelpUI';
import {Button, Icon, noop, PriorityIcon, Title} from '@priority-software/priority-style-react';
import {FormView} from '../FormView';
import {SubForms} from '../SubForms/SubForms';
import {isRTL} from '../../../../Localization';
import {useEventListener} from '../../../../hooks/useEventListener';
import {keys} from '../../../../constants/KeyCodes';
import {isNavigationLocked} from '../../utils/isNavigationLocked';
import styles from './styles.module.scss';
import {createDataTestId} from '../../../../utils/dataTestId';

type Props = {
    currentForm: Form;
    runSubForm: (subFormName: string, parentLevel: number) => void;
    closeRecordDialog: () => void;
    isApiLock: () => boolean;
    disabledSubformList: boolean;
};

export const NewRecordDialog = observer((props: Props) => {
    const {currentForm, runSubForm, closeRecordDialog, isApiLock, disabledSubformList} = props;

    useEventListener('keydown', e => {
        if (!isNavigationLocked(currentForm)) {
            if (e.key === keys.ESC) {
                closeRecordDialog();
            }
        }
    });

    return (
        <div className={styles.component}>
            <div className={styles.inner} {...createDataTestId('screen-toolbar', false)}>
                <header className={styles.dialogHeader}>
                    <Button
                        skin="primary"
                        onClick={closeRecordDialog}
                        prefixIcon={isRTL() ? PriorityIcon.arrowRight : PriorityIcon.arrowLeft}
                    >
                        {texts.backTo}
                    </Button>

                    <div className={styles.toolbar}>
                        <HeaderHelpButton tooltipPosition="bottom-end" />

                        <div className={styles.divider} />
                        <Icon icon={PriorityIcon.match} onClick={closeRecordDialog} />
                    </div>
                </header>

                <div
                    className={styles.formHeader}
                    {...createDataTestId('form-header-with-add', false)}
                >
                    <Title skin="h3" textColor="primary-500">
                        {texts.addLabel} {currentForm.title}
                    </Title>

                    <div className={styles.btnGroup}>
                        <Icon icon={PriorityIcon.settings} />
                    </div>
                </div>

                <div className={styles.mainForm}>
                    <FormView
                        sectionClass={styles.sectionClass}
                        currentForm={currentForm}
                        isActiveForm={formsStore.currentScreen?.activeLevel === currentForm?.level}
                    />
                </div>

                <div className={styles.subform}>
                    <SubForms
                        parentLevel={currentForm.level}
                        disabledSubformList={disabledSubformList}
                        isApiLock={isApiLock}
                        subForm={currentForm.activeTabSubForm}
                        subFormsList={currentForm.subFormsList}
                        runSubForm={runSubForm}
                        openSelectListModal={noop}
                    />
                </div>
            </div>
        </div>
    );
});
